import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadStudentSupports } from './../../../../ng2/store/actions/student-supports-actions';
import {
  getStudentSupportsEntitiesList,
  getStudentSupportsLoadedStatus,
} from './../../../../ng2/store/selectors/student-supports-selectors';

@Injectable()
export class StudentSupportsResolver {
  resolveStudentSupports$(currentSchool, store): Promise<Observable<any>> {
    const { _id } = currentSchool;
    const payload = { schoolId: _id };
    const destroy$: Subject<boolean> = new Subject<boolean>();

    return new Promise(resolve => {
      store
        .select(getStudentSupportsLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new LoadStudentSupports(payload));
          if (loaded) {
            const studentSupports$ = store.select(getStudentSupportsEntitiesList);
            destroy$.next(true);
            destroy$.unsubscribe();

            resolve(studentSupports$);
          }
        });
    });
  }
}
